module.exports = __webpack_public_path__ + "img/image (1).c14cd12d.webp";